window.obtain=function (){
    $(".yzm_djs").show();
    $(".yzm_btn").hide();
    var djs = 59;
    var timeDjs = setInterval(function() {
        if (djs > 1) {
            djs--;
            $(".yzm_djs span").html(djs);
        } else {
            clearInterval(timeDjs);
            $(".yzm_djs span").html("59");
            $(".yzm_btn").show();
            $(".yzm_djs").hide()
        }
    }, 1000);
};